const topics = [
  { label: '古装仙侠', count: '3.2万', hot: true },
  { label: '悬疑探案', count: '2.8万', hot: true },
  { label: '都市情感', count: '2.5万', hot: false },
  { label: '韩剧热播', count: '4.1万', hot: true },
  { label: '谍战军旅', count: '1.9万', hot: false },
  { label: '甜宠爱情', count: '3.5万', hot: true },
  { label: '美剧精选', count: '2.2万', hot: false },
  { label: '刑侦犯罪', count: '2.6万', hot: false },
  { label: '年代传奇', count: '1.7万', hot: false },
  { label: '青春校园', count: '3.0万', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          热门话题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          追剧同好都在讨论这些
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-colors ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
              )}
              {topic.label}
              <span className="text-xs opacity-60">{topic.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}